import gql from 'graphql-tag';

/**
 * Assign a result template to a programme (tertiary schools only)
 */
export const ASSIGN_RESULT_TEMPLATE_TO_PROGRAMME = gql`
  mutation AssignResultTemplateToProgramme(
    $programme_id: ID!
    $academic_calendar_id: ID!
    $result_template_id: ID!
    $historical_source_map: [HistoricalSourceMapInput!]
  ) {
    assignResultTemplateToProgramme(
      programme_id: $programme_id
      academic_calendar_id: $academic_calendar_id
      result_template_id: $result_template_id
      historical_source_map: $historical_source_map
    ) {
      id
      program_name
      prog_code
      resultTemplates {
        id
        name
      }
    }
  }
`;

/**
 * Assign one result template to many programmes x many semesters in a single
 * all-or-nothing write (tertiary schools only). With overwrite=false, pairs that
 * already use a different template come back as conflicts and nothing is written.
 */
export const ASSIGN_RESULT_TEMPLATE_TO_PROGRAMMES = gql`
  mutation AssignResultTemplateToProgrammes($input: AssignResultTemplateToProgrammesInput!) {
    assignResultTemplateToProgrammes(input: $input) {
      applied
      assigned
      unchanged
      overwritten
      conflicts {
        programme_id
        programme_name
        academic_calendar_id
        calendar_name
        current_template_id
        current_template_name
      }
    }
  }
`;

/**
 * Set (or clear, with a null template) the "all semesters" default result
 * template for several programmes at once (tertiary schools only).
 */
export const SET_PROGRAMMES_RESULT_TEMPLATE_DEFAULT = gql`
  mutation SetProgrammesResultTemplateDefault($programme_ids: [ID!]!, $result_template_id: ID) {
    setProgrammesResultTemplateDefault(programme_ids: $programme_ids, result_template_id: $result_template_id) {
      id
      default_result_template_id
      default_result_template {
        id
        name
      }
    }
  }
`;

/**
 * Accept courses for programme transfer
 * Used when a student transfers from one programme to another
 */
export const ACCEPT_COURSES_FOR_PROGRAMME = gql`
  mutation AcceptCoursesForProgramme(
    $target_programme_id: ID!
    $course_registered_ids: [ID!]!
  ) {
    acceptCoursesForProgramme(
      target_programme_id: $target_programme_id
      course_registered_ids: $course_registered_ids
    ) {
      id
      course {
        id
        course_code
        course_title
        unit
      }
      is_transferred
      accepted_for_programme_id
      acceptedForProgramme {
        id
        program_name
      }
      acceptedByUser {
        id
        name
      }
      accepted_at
    }
  }
`;

/**
 * Revoke previously accepted course transfers
 */
export const REVOKE_COURSES_FROM_PROGRAMME = gql`
  mutation RevokeCoursesFromProgramme($course_registered_ids: [ID!]!) {
    revokeCoursesFromProgramme(course_registered_ids: $course_registered_ids) {
      id
      is_transferred
      accepted_for_programme_id
    }
  }
`;
